// extracted by mini-css-extract-plugin
module.exports = {"root":"FormattedText_root__O4Hvg"};